import ApiBase from '../ApiBase';

class MainStageSettings extends ApiBase {
    route = 'me/main-stage-settings';
}

export default new MainStageSettings();
